import styled, { css } from 'styled-components';

import { mediaQuery } from '@catalyze/ui';

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 0.5rem;
    ${mediaQuery(
        2,
        css`
            margin-left: 3rem;
        `
    )}
`;

// Refactor font-size to UI when refactoring FA
export const Heading = styled.h1`
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.fontPrimary};
    font-weight: 700;
    line-height: calc(4 / 3);
    margin-bottom: -0.25rem;
`;
